import { StyleSheet } from "@react-pdf/renderer";

const colors = {
    white: "#FFFFFF",
    black: "#000000",
    primaryText: "#1F2937",
    mutedText: "#6B7280",
    accent: "#4472C4",
    border: "#D1D5DB",
    borderDark: "#000000",
    sectionHeaderBg: "#4472C4",
    kvHeaderBg: "#F3F4F6",
    kvTitleBg: "#F9FAFB",
};

const styles = StyleSheet.create({
    page: {
        backgroundColor: colors.white,
        fontSize: 10,
        position: "relative",
        fontFamily: "Open Sans",
        paddingBottom: 30,
    },
    page1: {
        backgroundColor: colors.white,
        fontSize: 10,
        position: "relative",
        fontFamily: "Open Sans",
        paddingBottom: 30,
    },
    content: {
        paddingHorizontal: 30,
        paddingTop: 16,
    },
    sectionBlock: {
        marginBottom: 20,
    },
    sectionTitle: {
        width: "100%",
        backgroundColor: colors.sectionHeaderBg,
        fontWeight: 600,
        fontSize: 13,
        color: colors.white,
        paddingVertical: 4,
        paddingHorizontal: 20,
        marginBottom: 12,
        marginTop: 10,
    },
    subSectionTitle: {
        fontSize: 11,
        fontWeight: 600,
        color: colors.accent,
        marginBottom: 8,
        marginTop: 4,
    },
    wordSectionContent: {
        paddingHorizontal: 24,
        paddingTop: 12,
    },
    wordOverviewLabel: {
        fontSize: 12,
        fontWeight: 600,
        color: colors.accent,
        marginBottom: 8,
    },
    wordOverviewBody: {
        fontSize: 10,
        color: colors.primaryText,
        marginBottom: 12,
        lineHeight: 1.35,
    },
    wordTableHeaderCell: {
        backgroundColor: colors.accent,
    },
    wordTableHeaderText: {
        color: colors.white,
        textAlign: "center",
    },
    tocContent: {
        paddingHorizontal: 24,
        paddingTop: 16,
    },
    tocHeading: {
        width: "100%",
        backgroundColor: colors.sectionHeaderBg,
        fontWeight: 600,
        fontSize: 13,
        color: colors.white,
        paddingVertical: 4,
        paddingHorizontal: 20,
        marginBottom: 14,
    },
    tocList: {
        paddingHorizontal: 4,
    },
    tocRow: {
        flexDirection: "row",
        alignItems: "flex-end",
        marginBottom: 6,
    },
    tocChildRow: {
        flexDirection: "row",
        alignItems: "flex-end",
        marginBottom: 4,
        paddingLeft: 16,
    },
    tocLabel: {
        fontSize: 10,
        fontWeight: 600,
        fontStyle: "italic",
        color: colors.black,
        maxWidth: "78%",
    },
    tocChildLabel: {
        fontSize: 9,
        fontWeight: 400,
        fontStyle: "normal",
        color: colors.black,
        maxWidth: "78%",
    },
    tocDots: {
        flexGrow: 1,
        borderBottomWidth: 1,
        borderBottomColor: colors.border,
        borderStyle: "dotted",
        marginHorizontal: 6,
        marginBottom: 3,
        minWidth: 12,
    },
    tocPage: {
        fontSize: 10,
        fontWeight: 600,
        fontStyle: "italic",
        color: colors.black,
        minWidth: 16,
        textAlign: "right",
    },
    tocChildPage: {
        fontSize: 9,
        fontWeight: 400,
        fontStyle: "normal",
        color: colors.black,
        minWidth: 16,
        textAlign: "right",
    },
    kvTable: {
        display: "table",
        width: "auto",
        marginBottom: 10,
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: colors.borderDark,
    },
    kvTableRow: {
        flexDirection: "row",
        borderBottom: `1px solid ${colors.borderDark}`,
    },
    kvTableLastRow: {
        borderBottom: "none",
    },
    kvTableHeaderCol: {
        width: "50%",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "flex-start",
        backgroundColor: colors.kvHeaderBg,
        borderRight: `1px solid ${colors.borderDark}`,
    },
    kvTableTitleCol: {
        width: "50%",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "flex-start",
        backgroundColor: colors.kvTitleBg,
        borderRight: `1px solid ${colors.borderDark}`,
        paddingTop: 2,
        paddingBottom: 2,
    },
    kvTableDetailCol: {
        width: "50%",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "flex-start",
        paddingTop: 2,
        paddingBottom: 2,
    },
    kvTableCell: {
        margin: 5,
        fontSize: 8,
        flexDirection: "row",
        alignItems: "center",
        flexGrow: 1,
        flexShrink: 1,
        flexBasis: 0,
        maxWidth: "100%",
        wordWrap: "break-word",
        whiteSpace: "normal",
        overflow: "hidden",
    },
    kvTableDetailText: {
        color: colors.accent,
    },
    metricGrid: {
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        marginBottom: 12,
    },
    metricItem: {
        width: "50%",
        paddingRight: 8,
        marginBottom: 10,
    },
    metricLabel: {
        fontSize: 8,
        fontWeight: 600,
        color: colors.primaryText,
        marginBottom: 2,
    },
    metricValue: {
        fontSize: 9,
        color: colors.accent,
    },
    emptyStateText: {
        fontSize: 9,
        color: colors.mutedText,
        fontStyle: "italic",
        marginBottom: 8,
    },
    coverContent: {
        paddingHorizontal: 30,
        paddingTop: 20,
        paddingBottom: 10,
    },
    coverPage: {
        flexGrow: 1,
    },
    coverFields: {
        flexGrow: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        paddingTop: 80,
        paddingBottom: 80,
        paddingLeft: 40,
        paddingRight: 40,
    },
    coverField: {
        marginBottom: 28,
        textAlign: "center",
        width: "100%",
    },
    coverLabel: {
        fontSize: 12,
        fontWeight: 600,
        marginBottom: 6,
        textAlign: "center",
    },
    coverValue: {
        fontSize: 12,
        textAlign: "center",
    },
    ml1: {
        marginLeft: 4
    },
    section: {
        padding: '0px 50px',
        height: 'auto',
        flexGrow: 1
    },
    note: {
        fontSize: 9,
        color: '#4472c4',
        padding: '0px 35px',
        marginBottom: 10,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'start'
    },
    generalInfosRow: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        marginTop: 12
    },
    generalInfosRowCol: {
        width: '50%',
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'center'
    },
    generalInfosTitle: {
        fontWeight: 'bold'
    },
    generalInfosValue: {
        color: '#4472c4',
        fontWeight: 'normal'
    },
    aiGeneralDescription: {
        lineHeight: 1.5
    },
    sections: {
        padding: "0px 30px",
    },
    sectionSeparator: {
        width: '100%',
        backgroundColor: '#4472c4',
        fontWeight: 600,
        fontSize: 13,
        color: 'white',
        padding: "4px 20px",
        marginBottom: 20,
        marginTop: '10px'
    },
    generalInfos: {
        marginBottom: 20
    },
    table: {
        display: "table",
        width: "auto",
        marginBottom: '10px',
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: "#000",
    },
    tableRow: {
        flexDirection: "row",
        borderBottom: "1px solid #000"
    },
    tableLastRow : {
        borderBottom: 'none'
    },
    tableColHeader: {
        width: "50%",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "flex-start",
        backgroundColor: "#fff",
        borderRight: '1px solid #000',
    },
    fontBold: {
        fontWeight: "600"
    },
    tableCol: {
        width: "50%",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "flex-start",
        borderRight: '1px solid #000',
        paddingTop: 2,
        paddingBottom: 2
    },
    borderRightNone : {
        borderRight: 'none'
    },    
    tableCell: {
        margin: 5,
        fontSize: 8,
        flexDirection: "row",
        alignItems: "center",
        flexGrow: 1,
        flexShrink: 1, 
        flexBasis: 0, 
        maxWidth: "100%", 
        wordWrap: "break-word",
        whiteSpace: "normal",
        overflow: "hidden"
    },
    text: {
        fontSize: 10,
        marginBottom: 10,
    },
    alphListItem: {
        color: "blue",
        marginBottom: 12
    },
    managementSummaryContent: {
        paddingHorizontal: 24,
        paddingTop: 8,
    },
    managementSummaryBox: {
        backgroundColor: "rgba(86, 100, 210, 0.1)",
        borderWidth: 1,
        borderColor: "#5664D2",
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        borderBottomLeftRadius: 12,
        borderBottomRightRadius: 0,
        paddingHorizontal: 12,
        paddingTop: 10,
        paddingBottom: 12,
        marginBottom: 12,
    },
    managementSummaryTitle: {
        fontSize: 11,
        fontWeight: 600,
        color: colors.primaryText,
        marginBottom: 10,
    },
    summaryMetricsRow: {
        flexDirection: "row",
        marginBottom: 8,
    },
    summaryMetricCol: {
        flexGrow: 1,
        flexBasis: 0,
        paddingRight: 4,
    },
    summaryMetricLabel: {
        fontSize: 7,
        fontWeight: 600,
        color: colors.primaryText,
        marginBottom: 3,
    },
    summaryMetricValue: {
        fontSize: 8,
        color: colors.accent,
    },
    functionBadgesRow: {
        flexDirection: "row",
        flexWrap: "wrap",
    },
    functionBadge: {
        backgroundColor: "#59C94F",
        color: colors.white,
        fontSize: 6,
        fontWeight: 600,
        paddingVertical: 2,
        paddingHorizontal: 3,
        marginRight: 2,
        marginBottom: 2,
        textAlign: "center",
        minWidth: 16,
    },
    percentRing: {
        width: 34,
        height: 34,
        borderRadius: 17,
        borderWidth: 3,
        borderColor: colors.accent,
        alignItems: "center",
        justifyContent: "center",
    },
    percentRingText: {
        fontSize: 7,
        fontWeight: 600,
        color: colors.accent,
    },
    analyticsRow: {
        flexDirection: "row",
        borderWidth: 1,
        borderColor: colors.border,
        marginBottom: 12,
    },
    analyticsColumn: {
        flexGrow: 1,
        flexBasis: 0,
        padding: 8,
        borderRightWidth: 1,
        borderRightColor: colors.border,
    },
    analyticsColumnLast: {
        borderRightWidth: 0,
    },
    analyticsTitle: {
        fontSize: 9,
        fontWeight: 600,
        color: colors.primaryText,
        marginBottom: 8,
        textAlign: "left",
    },
    donutWrap: {
        alignItems: "center",
        justifyContent: "center",
        marginBottom: 6,
        position: "relative",
        width: 92,
        height: 92,
        alignSelf: "center",
    },
    donutSvg: {
        width: 92,
        height: 92,
    },
    chartPercentageLabel: {
        position: "absolute",
        fontSize: 7,
        fontWeight: 600,
        color: colors.primaryText,
    },
    donutCenterValue: {
        position: "absolute",
        fontSize: 10,
        fontWeight: 600,
        color: colors.mutedText,
    },
    legendRow: {
        flexDirection: "row",
        flexWrap: "wrap",
    },
    legendItemCompact: {
        flexDirection: "row",
        alignItems: "center",
        marginRight: 6,
        marginBottom: 3,
    },
    legendLabelCompact: {
        fontSize: 6,
        color: colors.mutedText,
    },
    legendItem: {
        flexDirection: "row",
        alignItems: "center",
        marginBottom: 3,
    },
    legendDot: {
        width: 6,
        height: 6,
        borderRadius: 3,
        marginRight: 4,
    },
    legendLabel: {
        fontSize: 7,
        color: colors.primaryText,
        flexGrow: 1,
    },
    legendValue: {
        fontSize: 7,
        color: colors.mutedText,
    },
    activityItem: {
        marginBottom: 7,
    },
    activityRow: {
        flexDirection: "row",
        alignItems: "flex-start",
    },
    activityIcon: {
        width: 10,
        height: 10,
        marginTop: 1,
        marginRight: 3,
    },
    activityBody: {
        flexGrow: 1,
        flexShrink: 1,
    },
    activityDate: {
        fontSize: 7,
        fontWeight: 600,
        color: colors.primaryText,
        marginBottom: 2,
    },
    activityText: {
        fontSize: 7,
        color: colors.mutedText,
    },
    riskMatrixTitle: {
        fontSize: 10,
        fontWeight: 600,
        color: colors.primaryText,
        marginBottom: 6,
    },
    riskMatrixTableWrap: {
        position: "relative",
    },
    riskMatrixTable: {
        borderWidth: 1,
        borderColor: colors.borderDark,
        marginTop: 2,
    },
    riskMatrixHeaderRow: {
        flexDirection: "row",
        borderBottomWidth: 1,
        borderBottomColor: "#FFFFFF",
    },
    riskMatrixRow: {
        flexDirection: "row",
        borderBottomWidth: 1,
        borderBottomColor: "#FFFFFF",
    },
    riskMatrixAxisLabelCell: {
        width: 38,
        minHeight: 24,
        borderRightWidth: 1,
        borderRightColor: "#FFFFFF",
        backgroundColor: "#F0F1FF",
        alignItems: "center",
        justifyContent: "center",
    },
    riskMatrixAxisValueCell: {
        width: 38,
        minHeight: 24,
        borderRightWidth: 1,
        borderRightColor: "#FFFFFF",
        backgroundColor: "#F0F1FF",
        alignItems: "center",
        justifyContent: "center",
    },
    riskMatrixBodyRow: {
        flexDirection: "row",
    },
    riskMatrixLikelihoodAxisLabelColumn: {
        width: 38,
        borderRightWidth: 1,
        borderRightColor: "#FFFFFF",
        backgroundColor: "#F0F1FF",
        position: "relative",
        alignItems: "center",
        justifyContent: "center",
    },
    riskMatrixDataRows: {
        flexGrow: 1,
        flexDirection: "column",
    },
    riskMatrixYAxisCell: {
        width: 38,
        minHeight: 47,
        borderRightWidth: 1,
        borderRightColor: "#FFFFFF",
        borderBottomWidth: 1,
        borderBottomColor: "#FFFFFF",
        backgroundColor: "#F0F1FF",
        justifyContent: "center",
        alignItems: "center",
    },
    riskMatrixConsequenceBand: {
        flexGrow: 1,
        minHeight: 24,
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#F0F1FF",
    },
    riskMatrixConsequenceText: {
        fontSize: 7,
        fontWeight: 600,
        color: colors.primaryText,
    },
    riskMatrixLikelihoodText: {
        position: "absolute",
        left: -78,
        width: 200,
        height: 30,
        fontSize: 6,
        color: colors.primaryText,
        textAlign: "center",
        fontWeight: 500,
        transform: "rotate(270deg)",
    },
    riskMatrixYAxisText: {
        fontSize: 6,
        textAlign: "center",
        fontWeight: 500,
    },
    riskMatrixXAxisCell: {
        flexGrow: 1,
        flexBasis: 0,
        minHeight: 18,
        borderRightWidth: 1,
        borderRightColor: "#FFFFFF",
        justifyContent: "center",
        alignItems: "center",
        paddingHorizontal: 1,
        backgroundColor: "#F0F1FF",
    },
    riskMatrixXAxisText: {
        fontSize: 5,
        textAlign: "center",
    },
    riskMatrixCell: {
        flexGrow: 1,
        flexBasis: 0,
        minHeight: 26,
        borderRightWidth: 1,
        borderRightColor: "#FFFFFF",
        justifyContent: "flex-end",
        paddingHorizontal: 3,
        paddingBottom: 2,
    },
    matrixRiskCellBottom: {
        flexDirection: "row",
        alignItems: "flex-end",
        justifyContent: "space-between",
    },
    matrixBulletsWrap: {
        flexDirection: "row",
        flexWrap: "wrap",
        maxWidth: "78%",
    },
    matrixRiskBullet: {
        width: 8,
        height: 8,
        borderRadius: 4,
        backgroundColor: "#828282",
        borderWidth: 1,
        borderColor: "#FFFFFF",
        marginRight: 2,
        marginBottom: 2,
    },
    matrixCountWrap: {
        flexDirection: "row",
        alignItems: "center",
    },
    riskMatrixCellText: {
        fontSize: 6,
        color: colors.white,
        fontWeight: 600,
    },
    riskRatingDot: {
        width: 8,
        height: 8,
        borderRadius: 4,
    },
    complianceTableWrap: {
        marginBottom: 12,
    },
    complianceGroupHeaderRow: {
        flexDirection: "row",
        marginBottom: 4,
    },
    complianceInputGroupHeader: {
        width: "78%",
        backgroundColor: "#FFDADA",
        paddingVertical: 4,
        paddingHorizontal: 6,
        borderWidth: 1,
        borderColor: colors.borderDark,
    },
    complianceResultGroupHeader: {
        width: "22%",
        backgroundColor: "#E9E9EA",
        paddingVertical: 4,
        paddingHorizontal: 6,
        borderWidth: 1,
        borderLeftWidth: 0,
        borderColor: colors.borderDark,
    },
    complianceGroupHeaderText: {
        fontSize: 8,
        fontWeight: 600,
        textAlign: "center",
        color: colors.primaryText,
    },
    complianceTable: {
        borderWidth: 1,
        borderColor: colors.borderDark,
    },
    complianceHeaderRow: {
        flexDirection: "row",
        borderBottomWidth: 1,
        borderBottomColor: colors.borderDark,
    },
    complianceDataRow: {
        flexDirection: "row",
        borderBottomWidth: 1,
        borderBottomColor: colors.borderDark,
    },
    complianceInputGroup: {
        width: "78%",
        flexDirection: "row",
    },
    complianceResultGroup: {
        width: "22%",
        flexDirection: "row",
    },
    complianceSubRowSpacer: {
        width: "78%",
        backgroundColor: "#FFDADA",
        borderRightWidth: 1,
        borderRightColor: colors.borderDark,
        minHeight: 18,
    },
    complianceHeaderCell: {
        flexGrow: 1,
        flexBasis: 0,
        justifyContent: "center",
        paddingVertical: 3,
        paddingHorizontal: 2,
        borderRightWidth: 1,
        borderRightColor: colors.borderDark,
        minHeight: 22,
    },
    complianceInputHeaderCell: {
        backgroundColor: "#FFDADA",
    },
    complianceResultHeaderCell: {
        backgroundColor: "#E9E9EA",
    },
    complianceBodyCell: {
        flexGrow: 1,
        flexBasis: 0,
        justifyContent: "center",
        paddingVertical: 3,
        paddingHorizontal: 2,
        borderRightWidth: 1,
        borderRightColor: colors.borderDark,
        minHeight: 20,
    },
    complianceInputBodyCell: {
        backgroundColor: "#FFDADA",
    },
    complianceResultBodyCell: {
        backgroundColor: "#E9E9EA",
    },
    complianceHeaderText: {
        fontSize: 6,
        fontWeight: 600,
        textAlign: "center",
        color: colors.primaryText,
    },
    complianceBodyText: {
        fontSize: 6,
        color: colors.primaryText,
    },
    complianceEmptyRow: {
        borderWidth: 1,
        borderColor: colors.borderDark,
        paddingVertical: 8,
        paddingHorizontal: 6,
    },
    complianceFindingsBlock: {
        borderLeftWidth: 1,
        borderRightWidth: 1,
        borderBottomWidth: 1,
        borderColor: colors.borderDark,
        backgroundColor: "#F9FAFB",
        paddingVertical: 6,
        paddingHorizontal: 10,
        marginBottom: 2,
    },
    complianceFindingsTitle: {
        fontSize: 8,
        fontWeight: 600,
        color: colors.accent,
        marginBottom: 4,
    },
    complianceFindingItem: {
        marginBottom: 4,
    },
    complianceFindingName: {
        fontSize: 7,
        fontWeight: 600,
        color: colors.primaryText,
        marginBottom: 2,
    },
    complianceFindingDescription: {
        fontSize: 6,
        color: colors.mutedText,
    },
});

export { colors };
export default styles;